import OnboardingPage from "../../common/components/OnboardingPage";
import { REWARD_OFFERING } from "../../constants";
import { getRedeemUrlWithContext } from "../../utils";

function ComingSoonFuelMain() {
  const redeemUrl = getRedeemUrlWithContext("coming-soon-fuel");


  return (
    <OnboardingPage
      redeemUrl={redeemUrl}
      rewardId={REWARD_OFFERING.comingsoonfuel}
      hideCTA={true}
    />
  );
}

export default ComingSoonFuelMain;